<template>
  <div
    v-if="initialized"
    class="flex h-full w-full"
  >
    <TheSidebarPartner v-if="!mq.isMobile" />
    <div class="flex h-full min-w-0 flex-1 flex-col bg-canvas">
      <OutOfOfficeBanner
        v-if="current_client.attributes.ooo"
        :client="current_client"
        :profile="current_profile"
      />
      <TheNavbartopPartner v-if="mq.isMobile" />
      <TheNavbarDesktopPartnerHorizontal v-if="!mq.isMobile" />
      <main class="h-full w-full overflow-y-auto">
        <div
          class="mx-auto max-w-[1800px] px-5 py-3"
          :class="{ 'h-full': $route.params.ticket_id }"
        >
          <router-view />
        </div>
      </main>
    </div>
    <TheNotificationsSidebar v-show="show_notification_sidebar" />
  </div>
  <ButtonImpersonateStop
    v-if="current_profile_true.type === PROFILE_TYPES.EMPLOYEE"
    :profile="current_profile"
  />
</template>

<script setup>
import TheSidebarPartner from '@/app/_partners/components/navbar/TheSidebarPartner.vue';
import TheNavbarDesktopPartnerHorizontal from '@/app/_partners/components/navbar/TheNavbarDesktopPartnerHorizontal.vue';
import TheNavbartopPartner from '@/app/_partners/components/navbar/TheNavbartopPartner.vue';
import OutOfOfficeBanner from '@/app/shared_components/banner/TheOutOfOfficeBanner.vue';
import ButtonImpersonateStop from '@/app/shared_components/buttons/ButtonImpersonateStop.vue';
import TheNotificationsSidebar from '@/app/shared_components/navbar/notifications/TheNotificationsSidebar.vue';
import SIDEBAR_NOTIFICATIONS from '@/app/data/sidebar_constants';
import { PROFILE_TYPES } from '@/app/data/model_constants';
import { computed, onBeforeMount } from 'vue';
import useProfile from '@/app/composables/useProfile';

const { current_client, current_profile, current_profile_true, initialized, initProfile, sidebar_type } = useProfile();

const show_notification_sidebar = computed(() => sidebar_type.value === SIDEBAR_NOTIFICATIONS);

onBeforeMount(() => initProfile());
</script>
